import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* HERO SECTION - Above the Fold */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Build a Career in Data Analytics, Data Engineering and Data Science with AI
            </h1>
            <p className="hero-subtitle">
              Online programs across India | Offline classroom learning in Bhubaneswar
            </p>
            
            {/* Trust Points */}
            <div className="trust-points">
              <div className="trust-point">
                <div className="trust-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 3H3C1.9 3 1 3.9 1 5V19C1 20.1 1.9 21 3 21H21C22.1 21 23 20.1 23 19V5C23 3.9 22.1 3 21 3ZM21 19H3V5H21V19Z" fill="currentColor"/>
                    <path d="M15 10.5L10.5 7.5V13.5L15 10.5Z" fill="currentColor"/>
                  </svg>
                </div>
                <span>Live Interactive Classes</span>
              </div>
              <div className="trust-point">
                <div className="trust-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                    <path d="M19 10H17V8H19V10ZM19 14H17V12H19V14ZM19 18H17V16H19V18Z" fill="currentColor"/>
                  </svg>
                </div>
                <span>Trainers with Practical Experience</span>
              </div>
              <div className="trust-point">
                <div className="trust-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19Z" fill="currentColor"/>
                    <path d="M12 9L8 13H11V17H13V13H16L12 9Z" fill="currentColor"/>
                  </svg>
                </div>
                <span>Real-World Projects</span>
              </div>
              <div className="trust-point">
                <div className="trust-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
                    <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor"/>
                  </svg>
                </div>
                <span>Career-Focused Learning</span>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="hero-cta">
              <Link to="/academy/contact" className="btn btn-hero-primary btn-large">
                Talk to a Career Expert
              </Link>
              <button className="btn btn-hero-secondary btn-large" onClick={() => alert('Download Brochure feature coming soon!')}>
                Download Brochure
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO SECTION - SEO Depth */}
      <section className="intro-section section">
        <div className="container">
          <div className="intro-content">
            <h2 className="intro-heading">About Qbeta Academy</h2>
            <p className="intro-text">
              Qbeta Academy is a career-focused learning platform specializing in Data Analytics, Data Engineering, and Data Science with AI. We offer online programs across India and offline classroom learning in Bhubaneswar to help students and professionals build strong, job-ready data skills.
            </p>
            <p className="intro-text">
              Our mission is to bridge the gap between academic knowledge and real industry expectations in the data domain. Through hands-on projects, real-world tools, and expert mentorship, we prepare learners to confidently step into data-driven roles.
            </p>
            <p className="intro-text">
              Whether you are a student, a fresher, or a working professional looking to switch into the data field, Qbeta Academy helps you choose the right learning path and supports you from training to career opportunities.
            </p>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US - Differentiation */}
      <section className="why-choose section" style={{ backgroundColor: '#F5F5F5' }}>
        <div className="container">
          <h2 className="section-title">What Makes Qbeta Academy Different</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" fill="currentColor"/>
                  <path d="M19 10H17V8H19V10ZM19 14H17V12H19V14ZM19 18H17V16H19V18Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Specialized focus on data careers</h3>
              <p>We focus exclusively on Data Analytics, Data Engineering, and Data Science with AI.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                  <path d="M14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Industry-Aligned Curriculum</h3>
              <p>Curriculum aligned with real data industry requirements and continuously updated.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19Z" fill="currentColor"/>
                  <path d="M12 9L8 13H11V17H13V13H16L12 9Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Hands-on Real-World Projects</h3>
              <p>Learn using real datasets and industry-style projects throughout the program.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 11 9.66 11 8C11 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Strong Focus on Portfolio & Interviews</h3>
              <p>Dedicated support for resume building, portfolio creation, and interview preparation.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Continuous Mentorship</h3>
              <p>Career guidance and continuous mentorship from industry professionals.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
                  <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Online & Offline Options</h3>
              <p>Learn online from anywhere in India or attend offline classes in Bhubaneswar.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PROGRAMS SECTION - High SEO Value */}
      <section className="programs-section section">
        <div className="container">
          <h2 className="section-title">Our Career-Focused Programs</h2>
          <div className="programs-grid">
            <div className="program-card program-analytics">
              <div className="program-badge">Data Analytics</div>
              <h3>Data Analytics Program</h3>
              <p>Learn how to analyze, interpret, and communicate data-driven insights using SQL, Python, Excel, Power BI, and business analytics concepts.</p>
              <div className="program-best-for">
                <strong>Best for:</strong> Freshers, working professionals, career switchers
              </div>
              <Link to="/data-analytics-course" className="btn btn-primary">
                View Data Analytics Course
              </Link>
            </div>

            <div className="program-card program-engineering">
              <div className="program-badge">Data Engineering</div>
              <h3>Data Engineering Program</h3>
              <p>Master data pipelines, ETL concepts, databases, cloud fundamentals, and large-scale data systems used in real organizations.</p>
              <div className="program-best-for">
                <strong>Best for:</strong> Professionals looking to move into engineering roles
              </div>
              <Link to="/data-engineering-course" className="btn btn-primary">
                View Data Engineering Course
              </Link>
            </div>

            <div className="program-card program-science">
              <div className="program-badge">Data Science & AI</div>
              <h3>Data Science & AI Program</h3>
              <p>Build expertise in machine learning, statistics, Python, and AI-driven problem solving with strong emphasis on business use cases.</p>
              <div className="program-best-for">
                <strong>Best for:</strong> Advanced learners and analytics professionals
              </div>
              <Link to="/data-science-ai-course" className="btn btn-primary">
                View Data Science & AI Course
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* HOW LEARNING WORKS */}
      <section className="learning-methodology section" style={{ backgroundColor: '#F5F5F5' }}>
        <div className="container">
          <h2 className="section-title">Our Learning Methodology</h2>
          <div className="methodology-list">
            <div className="methodology-item">
              <div className="method-number">1</div>
              <div className="method-content">
                <h3>Live concept-driven classes</h3>
                <p>Interactive sessions with real-time Q&A and hands-on practice</p>
              </div>
            </div>
            <div className="methodology-item">
              <div className="method-number">2</div>
              <div className="method-content">
                <h3>Weekly hands-on assignments</h3>
                <p>Practical exercises to reinforce learning and build confidence</p>
              </div>
            </div>
            <div className="methodology-item">
              <div className="method-number">3</div>
              <div className="method-content">
                <h3>Real-world case studies</h3>
                <p>Industry scenarios and business problems to solve</p>
              </div>
            </div>
            <div className="methodology-item">
              <div className="method-number">4</div>
              <div className="method-content">
                <h3>Capstone industry projects</h3>
                <p>End-to-end projects that showcase your skills</p>
              </div>
            </div>
            <div className="methodology-item">
              <div className="method-number">5</div>
              <div className="method-content">
                <h3>Resume, interview, and career mentoring</h3>
                <p>Personalized guidance for your career journey</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WHO THIS IS FOR */}
      <section className="who-section section">
        <div className="container">
          <h2 className="section-title">Who Can Join Our Programs</h2>
          <div className="who-grid">
            <div className="who-card who-for">
              <h3>This is for you if:</h3>
              <ul>
                <li>You are a fresher or final-year student</li>
                <li>You are a working professional (0–5 years)</li>
                <li>You want to build a career in Data or AI</li>
                <li>You prefer structured, mentor-led learning</li>
              </ul>
            </div>
            <div className="who-card who-not">
              <h3>This is not for you if:</h3>
              <ul>
                <li>You are looking for shortcuts</li>
                <li>You want only recorded videos</li>
                <li>You expect guaranteed placements</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* OUTCOMES SECTION */}
      <section className="outcomes-section section" style={{ backgroundColor: '#F5F5F5' }}>
        <div className="container">
          <h2 className="section-title">What You Will Achieve</h2>
          <div className="outcomes-grid">
            <div className="outcome-item">
              <div className="outcome-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="currentColor"/>
                  <path d="M7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Strong fundamentals in data and analytics</h3>
            </div>
            <div className="outcome-item">
              <div className="outcome-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20 6H16V4C16 2.89 15.11 2 14 2H10C8.89 2 8 2.89 8 4V6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM10 4H14V6H10V4ZM20 19H4V8H20V19Z" fill="currentColor"/>
                  <path d="M12 9L8 13H11V17H13V13H16L12 9Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Hands-on experience with real datasets</h3>
            </div>
            <div className="outcome-item">
              <div className="outcome-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 13H11V3H3V13ZM5 5H9V11H5V5ZM13 3V11H21V3H13ZM19 9H15V5H19V9ZM3 21H11V15H3V21ZM5 17H9V19H5V17ZM13 15V21H21V15H13ZM19 19H15V17H19V19Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Professional dashboards and projects</h3>
            </div>
            <div className="outcome-item">
              <div className="outcome-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="currentColor"/>
                  <path d="M12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Interview-ready confidence</h3>
            </div>
            <div className="outcome-item">
              <div className="outcome-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M2.81 14.12L5.64 11.29L8.17 10.79C11.39 6.41 17.55 4.22 19.78 4.22C19.78 6.45 17.59 12.61 13.21 15.83L12.71 18.36L9.88 21.19C9.34 21.73 8.47 21.73 7.93 21.19L7.24 20.5C6.7 19.96 6.7 19.09 7.24 18.55L10.07 15.72L10.57 13.19C10.57 13.19 7.68 13.19 2.81 14.12Z" fill="currentColor"/>
                </svg>
              </div>
              <h3>Industry-aligned portfolio</h3>
            </div>
          </div>
        </div>
      </section>

      {/* FREE VALUE SECTION */}
      <section className="free-section section">
        <div className="container">
          <div className="free-content">
            <h2 className="section-title">Experience Our Teaching Before You Enroll</h2>
            <p className="section-subtitle">
              Attend our free live sessions, workshops, and webinars to understand our teaching approach and course depth.
            </p>
            <div className="free-cta">
              <Link to="/academy/apply" className="btn btn-free-primary btn-large">
                Get in Touch
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
